/*
 * CircuitReport Messages
 *
 * This contains all the text for the CircuitReport component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  quarter: {
    id: 'app.containers.CircuitReport.quarter',
    defaultMessage: 'Quarter',
  },
  year: {
    id: 'app.containers.CircuitReport.year',
    defaultMessage: 'Year',
  },
  copyReport: {
    id: 'app.containers.CircuitReport.copyReport',
    defaultMessage: 'Copy link',
  },
  prefillEmail: {
    id: 'app.containers.CircuitReport.prefillEmail',
    defaultMessage: 'Prefill email',
  },
  copySuccessful: {
    id: 'app.containers.CircuitReport.copySuccessful',
    defaultMessage: 'Report link successfully copied to clipboard',
  },
  prolongDownloadLinkSuccess: {
    id: 'app.containers.CircuitReport.prolongDownloadLinkSuccess',
    defaultMessage: 'Report link successfully prolonged',
  },
  prolongDownloadLinkFailed: {
    id: 'app.containers.CircuitReport.prolongDownloadLinkFailed',
    defaultMessage: 'Error. Failed to prolong report link.',
  },
  prolongDownloadLink: {
    id: 'app.containers.CircuitReport.prolongDownloadLink',
    defaultMessage: 'Prolong download link',
  },
});
